import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { FiX } from 'react-icons/fi';
import {
  Body,
  CloseButton,
  Content,
  Header,
  Overlay,
  Portal,
  Title,
} from './styles';

const TRANSITION_MS = 240;

const Sheet = ({
  open,
  onClose,
  title,
  children,
  connection = {},
  headerRight = null,
}) => {
  const [rendered, setRendered] = useState(open);
  const [isOpen, setIsOpen] = useState(open);

  useEffect(() => {
    let timeoutId;
    if (open) {
      setRendered(true);
      timeoutId = setTimeout(() => setIsOpen(true), 10);
    } else if (rendered) {
      setIsOpen(false);
      timeoutId = setTimeout(() => setRendered(false), TRANSITION_MS);
    }

    return () => clearTimeout(timeoutId);
  }, [open, rendered]);

  if (!rendered) return null;

  const connData =
    connection && Object.keys(connection).length ? connection : null;

  return ReactDOM.createPortal(
    <Portal>
      <Overlay $open={isOpen} onClick={onClose}>
        <Content $open={isOpen} onClick={(e) => e.stopPropagation()}>
          <Header>
            <Title>{title}</Title>
            {headerRight}
            <CloseButton onClick={onClose} aria-label="close">
              <FiX size={18} color="#000" />
            </CloseButton>
          </Header>
          <Body>{children}</Body>
        </Content>
      </Overlay>
    </Portal>,
    document.body
  );
};

export default Sheet;
